// extracted by mini-css-extract-plugin
export default {"input":"Requisite_input__l0f4H","button":"Requisite_button__XTf+s"};